const Color = {
  colors: [
    '#F44336',
    '#E91E63',
    '#9C27B0',
    '#673AB7',
    '#3F51B5',
    '#2196F3',
    '#03A9F4',
    '#00BCD4',
    '#009688',
    '#4CAF50',
    '#8BC34A',
    '#CDDC39',
    '#FFEB3B',
    '#FFC107',
    '#FF9800',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B',
  ],

  get(count) {
    return {
      evenly: () => this.evenly(count),
      byStep: (step, start = 0) => this.byStep(count, step, start),
    };
  },

  evenly(count) {
    const { colors } = this;
    const total = colors.length;

    if (count >= total) {
      return [...colors];
    }

    const list = [];

    for (let i = 0; i < count; i += 1) {
      const idx =
        i * Math.floor(total / count) + Math.floor(total / (2 * count));
      list.push(colors[idx]);
    }

    return list;
  },

  byStep(count, step = 2, start = 0) {
    const { colors } = this;

    const list = [];
    let base = start;
    let i = 0;

    while (list.length < count) {
      const idx = (base % colors.length) + Math.floor(i * step);

      if (colors[idx]) {
        list.push(colors[idx]);
        i += 1;
      } else {
        base += 1;
        i = 0;
      }
    }

    return list;
  },

  random() {
    const { colors } = this;

    return colors[Math.floor(Math.random() * colors.length)];
  },
};

export default Color;
